import React from 'react';
import { PropInfo, CodeExample } from '@cimpress/react-components';

import FlexBoxExampleOneCode from '!raw-loader!./flexboxExampleOne.jsx';
import FlexBoxExampleOne from './flexboxExampleOne';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const codeRegex = /.*(<FlexBox.*<\/FlexBox>).*/s;
const FlexBoxDocs = () => (
  <ComponentDoc
    name="FlexBox"
    propInfos={[]}
    remarks={'The FlexBox component exposes camelcased props that represent all possible css properties for flexbox'}
  >
    <FlexBoxExampleOne />
    <CodeExample code={FlexBoxExampleOneCode.match(codeRegex)[1]} />
  </ComponentDoc>
);

export default FlexBoxDocs;
